module.exports = __webpack_public_path__ + "img/neighbor-4-supp.9a5cfdb8.png";